import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import _moment from 'moment';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { TranslateService } from '@ngx-translate/core';

import { default as _rollupMoment } from 'moment';
import { MappingComponent } from 'src/app/mapping/mapping.component';
import {MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM-DD',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'YYYY-MM-DD',
  },
};

@Component({
    selector: 'app-overlay-analysis-dialog',
    templateUrl: './overlay-analysis-dialog.component.html',
    styleUrls: ['./overlay-analysis-dialog.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class OverlayAnalysisDialogComponent implements OnInit {

  date;
  maxDate = new Date();
  public varRequired;
  public varDate;
  public validation_messages;

  overlayAnalysisForm: any = new FormGroup({
    analysis: new FormControl(1, Validators.compose([
      Validators.required
    ])),
    date: new FormControl(moment(), Validators.compose([
      Validators.required
    ]))
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MappingComponent>,
    public translate: TranslateService
  ) { 
    this.validation_messages = {
      'date': [
        { type: 'required', message: translate.instant('OVERLAY-ALL-DIALOG.ERROR-DATE') }
      ]
    }

    if (this.data.date != null) {
      this.overlayAnalysisForm.setValue({ analysis: "ndvi", date: this.data.date });
      this.date = moment(this.data.date);
    }
  }

  ngOnInit(): void {

  }

  dateChanged(event: MatDatepickerInputEvent<Date>) {
    this.date = event.value;
  }

  onSubmit() {
    let analysis = this.overlayAnalysisForm.controls.analysis.value;

    let overlayAnalysis = {
      "date": this.date.format("YYYY-MM-DD"),
      "analysis": analysis
    };

    this.dialogRef.close({ "overlayAnalysis": overlayAnalysis });
  }


}
